export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12154.86914bd6.jpg";